import createLumirIcon from "../create-lumir-icon";

const Confirm = createLumirIcon("Confirm", [
  [
    "path",
    {
      key: "background-circle",
      d: "M10 18.3333C14.6024 18.3333 18.3334 14.6023 18.3334 9.99999C18.3334 5.39761 14.6024 1.66666 10 1.66666C5.39765 1.66666 1.66669 5.39761 1.66669 9.99999C1.66669 14.6023 5.39765 18.3333 10 18.3333Z",
      fill: "#7AD7B5",
    },
  ],
  [
    "path",
    {
      key: "checkmark",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.5908 8.09692L9.4959 13.7568L5.78632 10.0262L7.26362 8.55717L9.42065 10.7265L13.0424 6.70309L14.5908 8.09692Z",
      fill: "white",
    },
  ],
]);

export default Confirm;
